export default __webpack_public_path__ + "static/media/058-emergency diversion.cf3519dd.png";